import { Collapse, IconButton } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Close from "@material-ui/icons/Close";
import Alert from "@material-ui/lab/Alert";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { authenticateWithCredential } from "../../services/firebase";
import "./login.css";
import { ReactComponent as Logo } from "../../assets/logo.svg";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    width: "420px",
    maxWidth: "100%",
    margin: "auto",
    marginTop: "50px",
  },
  buttonGroup: {
    paddingTop: theme.spacing(4),
  },
  header: {
    paddingBottom: theme.spacing(3),
  },
}));

const SigninSchema = yup.object().shape({
  email: yup.string().email().required(),
  password: yup.string().required(),
});
type LoginType = { email: string; password: string };

export default function LoginPage() {
  const classes = useStyles();
  const { register, handleSubmit, errors } = useForm<LoginType>({
    validationSchema: SigninSchema,
  });

  const [errorOpen, setErrorOpen] = useState(false);

  const handleLogin = (data: LoginType) => {
    authenticateWithCredential({
      email: data.email,
      password: data.password,
    }).catch((err) => {
      setErrorOpen(true);
    });
  };

  return (
    <Paper className={classes.paper}>
      <Grid
        component="form"
        onSubmit={handleSubmit(handleLogin)}
        container
        spacing={2}
      >
        <Grid item xs={12}>
          <Typography className={classes.header}>
            <Logo className="svg-container"></Logo>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <TextField
            name="email"
            inputRef={register}
            required
            id="outlined-required"
            label="Email"
            defaultValue=""
            error={!!errors.email}
            helperText={errors.email?.message}
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            name="password"
            inputRef={register}
            required
            id="outlined-password-input"
            label="Password"
            type="password"
            error={!!errors.password}
            defaultValue=""
            helperText={errors.password?.message}
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <Collapse in={errorOpen}>
            <Alert
              color="error"
              severity="error"
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setErrorOpen(false);
                  }}
                >
                  <Close fontSize="inherit" />
                </IconButton>
              }
            >
              Le credenziali non sono corrette
            </Alert>
          </Collapse>
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            className={classes.buttonGroup}
            spacing={2}
            direction="row-reverse"
          >
            {/* <Grid item xs={12} md={6}>
              <Button
                variant="contained"
                color="default"
                type="submit"
                fullWidth
              >
                Recupera password
              </Button>
            </Grid> */}
            <Grid item xs={12} md={6}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                fullWidth
              >
                Accedi
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}
